var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_9565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7858 22.4999C41.7858 11.8487 33.1513 3.21423 22.5001 3.21423C11.8489 3.21423 3.21436 11.8487 3.21436 22.4999C3.21436 33.1512 11.8489 41.7857 22.5001 41.7857C33.1513 41.7857 41.7858 33.1512 41.7858 22.4999Z",
    fill: "#D9D2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0447 18.7501C25.0447 19.4157 25.5843 19.9554 26.25 19.9554C26.9158 19.9554 27.4554 19.4157 27.4554 18.7501H25.0447ZM22.5001 23.7054C23.1657 23.7054 23.7054 23.1658 23.7054 22.5001C23.7054 21.8344 23.1657 21.2947 22.5001 21.2947V23.7054ZM22.5001 21.2947C21.0947 21.2947 19.9554 20.1554 19.9554 18.7501H17.5447C17.5447 21.4869 19.7633 23.7054 22.5001 23.7054V21.2947ZM19.9554 18.7501C19.9554 17.3447 21.0947 16.2054 22.5001 16.2054V13.7947C19.7633 13.7947 17.5447 16.0133 17.5447 18.7501H19.9554ZM22.5001 16.2054C23.9054 16.2054 25.0447 17.3447 25.0447 18.7501H27.4554C27.4554 16.0133 25.2368 13.7947 22.5001 13.7947V16.2054Z",
    fill: "#37297B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9554 26.2501C19.9554 25.5843 19.4157 25.0447 18.75 25.0447C18.0844 25.0447 17.5447 25.5843 17.5447 26.2501H19.9554ZM22.5001 21.2947C21.8343 21.2947 21.2947 21.8344 21.2947 22.5C21.2947 23.1657 21.8343 23.7054 22.5001 23.7054V21.2947ZM25.0447 26.2501C25.0447 27.6554 23.9054 28.7947 22.5001 28.7947V31.2054C25.2368 31.2054 27.4554 28.9868 27.4554 26.2501H25.0447ZM22.5001 28.7947C21.0947 28.7947 19.9554 27.6554 19.9554 26.2501H17.5447C17.5447 28.9868 19.7633 31.2054 22.5001 31.2054V28.7947ZM22.5001 23.7054C23.9054 23.7054 25.0447 24.8447 25.0447 26.2501H27.4554C27.4554 23.5133 25.2368 21.2947 22.5001 21.2947V23.7054Z",
    fill: "#37297B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.8572V32.1429",
    stroke: "#37297B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7858 22.4999C41.7858 11.8487 33.1513 3.21423 22.5001 3.21423C11.8489 3.21423 3.21436 11.8487 3.21436 22.4999C3.21436 33.1512 11.8489 41.7857 22.5001 41.7857C33.1513 41.7857 41.7858 33.1512 41.7858 22.4999Z",
    stroke: "#EBE7FF",
    strokeWidth: 8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_9565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales_icon.49b645c00cc4ef5dcf7ef19c95c35ebe.svg";
export { ForwardRef as ReactComponent };